import { RenderedContent } from 'src/components/types';
import { BuildStatusesMap } from 'src/types';

import { BuildStatus } from './commit-status';
import { Link } from './link';
import { Repository } from './repository';
import { User } from './user';

type BBCommitAuthor = {
  raw: string;
  type: 'author';
  user?: User;
};

export type Participant = {
  approved: boolean;
  participated_on: string;
  role: 'PARTICIPANT';
  type: 'participant';
  user: User;
};

type BaseRef = {
  links: {
    commits: Link;
    self: Link;
    html: Link;
  };
  name: string;
  target: BBCommit;
};

type BBBranch = BaseRef & {
  type: 'branch';
};

type BBTag = BaseRef & { type: 'tag' };

type BBCommit = {
  author: BBCommitAuthor;
  date: Date;
  extra?: {
    branches?: BBBranch[];
    commentcount?: number;
    tags?: BBTag[];
    builds?: BuildStatus[];
    status_counts?: BuildStatusesMap;
  };
  hash: string;
  links: {
    self: Link;
    comments: Link;
    patch: Link;
    html: Link;
    diff: Link;
    approve: Link;
    request_changes: Link;
    statuses: Link;
  };
  message: string;
  parents?: BBCommit[];
  participants?: Participant[];
  repository: Repository;
  type: 'commit';
  summary?: RenderedContent;
  rendered?: {
    message: RenderedContent;
  };
  is_annotated: boolean;
};

declare global {
  namespace BB {
    type CommitAuthor = BBCommitAuthor;
    type Branch = BBBranch;
    type Tag = BBTag;
    type Commit = BBCommit;
  }
}

export type CommitAuthor = BBCommitAuthor;
export type Branch = BBBranch;
export type Tag = BBTag;
export type Commit = BBCommit;
